// extracted by mini-css-extract-plugin
export default {"title":"simulatedActivitiesTabs_title__sWhwI"};